import React from 'react';

const ImportOptions = ({ sendEmails, onSendEmailsChange }) => {
  return (
    <div className="mb-4">
      <h6>Step 3: Import Options</h6>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="sendEmails"
          checked={sendEmails}
          onChange={(e) => onSendEmailsChange(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="sendEmails">
          Send welcome emails to new users
        </label>
        <div className="text-muted small">
          Users will receive login credentials and instructions via email
        </div>
      </div>
    </div>
  );
};

export default ImportOptions;